@for (action of actions; track action.id)
{
<button type="button" kendoButton kendoPagerFocusable fillMode="flat" size="medium"
  [class]="action.navClass"
  [class.k-disabled]="buttonDisabled(action)"
  [disabled]="buttonDisabled(action)"
  [icon]="action.fontIcon"
  [svgIcon]="action.svgIcon"
  (click)="onAction(action.id)"
  title="{{ action.titleKey | translate }}"
  attr.aria-label="{{ action.titleKey | translate }}"
  [attr.aria-disabled]="buttonDisabled(action)">
</button>
}
@if (pageSizes && pageSizes.length > 0)
{
<kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
}
